var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuality = function SvgQuality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14642E",
    stroke: "#F8F8FD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M15.076 26.712 12.116 49l12.232-7.34L36.58 49l-2.96-22.312"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14642E",
    stroke: "#F8F8FD",
    strokeWidth: 1.8,
    d: "M6.45 17.136a4.087 4.087 0 0 1 1.42-5.297 4.09 4.09 0 0 0 1.863-3.228 4.09 4.09 0 0 1 3.878-3.878A4.09 4.09 0 0 0 16.84 2.87a4.09 4.09 0 0 1 5.297-1.419c1.17.6 2.558.6 3.728 0a4.09 4.09 0 0 1 5.297 1.42 4.09 4.09 0 0 0 3.228 1.863 4.09 4.09 0 0 1 3.878 3.878 4.09 4.09 0 0 0 1.863 3.228 4.087 4.087 0 0 1 1.42 5.297c-.6 1.17-.6 2.558 0 3.728a4.087 4.087 0 0 1-1.42 5.297 4.09 4.09 0 0 0-1.863 3.228 4.09 4.09 0 0 1-3.878 3.878 4.09 4.09 0 0 0-3.228 1.864 4.09 4.09 0 0 1-5.297 1.419c-1.17-.6-2.558-.6-3.728 0a4.09 4.09 0 0 1-5.297-1.42 4.09 4.09 0 0 0-3.228-1.863 4.09 4.09 0 0 1-3.878-3.878 4.09 4.09 0 0 0-1.863-3.228 4.087 4.087 0 0 1-1.42-5.297c.6-1.17.6-2.558 0-3.728Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3DC869",
    stroke: "#F8F8FD",
    strokeWidth: 1.8,
    d: "M34.555 18.994V19c0 5.811-4.708 10.555-10.555 10.555-5.81 0-10.554-4.708-10.554-10.555 0-5.811 4.707-10.555 10.554-10.555 5.852 0 10.591 4.748 10.555 10.55Z"
  })));
};
export default SvgQuality;